import { Form } from '@/components'
import useAuth from '@/hooks/useAuth'
import castrations from '@/services/api/castrations'
import React, { useLayoutEffect, useRef, useState } from 'react'
import { toast } from 'react-toastify'

function Terms() {
  const [loading, setLoading] = useState(false)
  const [content, setContent] = useState('')
  const textareaRef = useRef()
  const { licensing, setLicensing } = useAuth()

  async function onSubmit(event) {
    event?.preventDefault()
    try {
      setLoading(true)
      await castrations.updateCurrentTerms(content)
      toast.success('Termos atualizados com sucesso')
      setLicensing({ ...licensing, castrationTerms: content })
    } catch (e) {
      toast.error(e?.message)
      setLoading(false)
    }
  }

  useLayoutEffect(() => {
    textareaRef?.current?.focus()
  }, [])

  return (

    <div className="modal-container">
      <fieldset disabled={loading}>
        <form onSubmit={onSubmit}>

          <div className="modal-header">
            <div className="modal-title h5">Atualização dos termos da castração</div>
          </div>
          <div className="modal-body">
            <div className="content">
              <Form.Group>
                <Form.Label htmlFor="terms">
                  Informe os termos que o usuário deve concordar
                  para solicitar o serviço de castração.
                </Form.Label>
                <textarea
                  ref={textareaRef}
                  onInput={(e) => setContent(e.target.value)}
                  placeholder="Para solicitar este serviço você deve concordar com..."
                  id="terms"
                  cols="30"
                  rows="10"
                  className="form-input"
                  value={content}
                />
              </Form.Group>
            </div>
          </div>
          <div className="modal-footer">
            <button
              disabled={loading || !content}
              className={`btn btn-primary ${loading ? 'loading' : ''}`}
              type="submit"
            >
              <i className="fas fa-save" />
              &nbsp;Salvar termos
            </button>
          </div>
        </form>
      </fieldset>
    </div>
  )
}

export default Terms
